import { renderSlot as _renderSlot, createCommentVNode as _createCommentVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { ref: "root" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.renderItem)
      ? _renderSlot(_ctx.$slots, "default", {
          key: 0,
          ref: "lazyInitItem"
        })
      : _renderSlot(_ctx.$slots, "lazy-init-placeholder", { key: 1 })
  ], 512))
}